import types from './types';

const getRoomGalleryRequest = roomId => ({
  type: types.GET_ROOM_GALLERY_REQUEST,
  roomId
});

const getRoomGallerySuccess = dataGroupedByRoomId => ({
  type: types.GET_ROOM_GALLERY_SUCCESS,
  dataGroupedByRoomId
});

const getRoomGalleryFailure = () => ({
  type: types.GET_ROOM_GALLERY_FAILURE
});

export default {
  getRoomGalleryRequest,
  getRoomGallerySuccess,
  getRoomGalleryFailure
};
